import { CinemaService } from '@omnia/ui/src/lib/services/cinema.service'
import { PageBase } from '@omnia/ui/src/lib/services/models/pageBase'
import type { PagesEnum } from '@/shared/models/pages'
import { cmsService } from '@/web/common/services/cms.service'
import { navigationService } from '@/web/common/services/navigation.service'

export class CmsCinemaElement extends PageBase {
    public addressLine1: string
    public addressLine2: string
    public addressLine3: string
    public postCode: string
    public foodAndBeverageEnabled: boolean
    public vistaCinema: { key: string; value: string }
}

class KinepolisCinemaService extends CinemaService<CmsCinemaElement, PagesEnum> {
    protected cinemasPage: keyof PagesEnum = 'Cinemas'
    protected cinemaElementProperties: Array<keyof CmsCinemaElement> = [
        'addressLine1',
        'addressLine2',
        'addressLine3',
        'postCode',
        'foodAndBeverageEnabled',
        'vistaCinema',
    ]

    private cinemas = new Map<string, CmsCinemaElement>()

    public async loadCinemas(reload: boolean = false) {
        if (this.cinemas.size === 0 || reload) {
            try {
                const data = await cmsService.loadPageList<CmsCinemaElement>(
                    this.cinemaElementProperties,
                    navigationService.getPageUrl('Cinemas')
                )

                this.cinemas.clear()

                data.forEach(cmsCinema => {
                    if (cmsCinema.alias === 'cinema' && cmsCinema.vistaCinema) {
                        this.cinemas.set(cmsCinema.vistaCinema.key, cmsCinema)
                    }
                })
            } catch (error) {
                console.error(error)
            }
        }
    }

    public async navigateToCinemaById(id: string, params?: { [key: string]: string }) {
        await this.loadCinemas()
        if (this.cinemas.has(id)) {
            const newLocation = `${this.cinemas.get(id)?.url || ''}${params ? navigationService.getQueryParams(params) : ''}`
            navigationService.goTo(newLocation)
        }
    }
}

export const cinemaService = new KinepolisCinemaService()
